import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import BuyHoldReport from "../../@Components/Products/BuyHoldReport";

const BuyHold: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <BuyHoldReport />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default BuyHold;
